"use client";

import { useLanguage } from '@/context/LanguageContext'
import { Container } from '@/components/common/Container'
import { FadeIn } from '@/components/FadeIn'
import {SectionIntro} from "@/components/SectionIntro";
import {StylizedImage} from "@/components/StylizedImage";
import imageLaptop from "@/images/laptop-1024.webp";
import {List, ListItem} from "@/components/List";

const texts = {
    en: {
        services: 'Services',
        servicesTitle: 'I help you respond to new opportunities.',
        servicesDescription: 'Invest in your ideas: I shape them into tailor-made solutions.',
        webDevelopmentTitle: 'Web development',
        webDevelopmentDescription: 'I specialize in creating web apps. Thanks to the Laravel and Angular framework I can shape your idea.',
        consultingTitle: 'Consulting',
        consultingDescription: 'I offer support in the selection of the most suitable software and hardware, with attention to cybersecurity as well.',
        appDevelopmentTitle: 'Application development',
        appDevelopmentDescription: 'I develop native applications for Apple and Android and cross-platform solutions, guaranteeing high performance and an excellent user experience.',
        cmsTitle: 'Content management system',
        cmsDescription: 'I understand the importance of a robust and customizable CMS. For this I offer solutions based on WordPress, study to adapt perfectly to your needs.',
        cloudAndServerSolutionsTitle: 'Cloud and server solutions',
        cloudAndServerSolutionsDescription: 'With my expertise I can help you in the Google, Oracle and Microsoft cloud areas, server on-premise and network devices management.',
    },
    it: {
        services: 'Servizi',
        servicesTitle: 'Ti aiuto a cogliere le nuove opportunità.',
        servicesDescription: 'Investi nelle tue idee: io le plasmo in soluzioni su misura.',
        webDevelopmentTitle: 'Sviluppo web',
        webDevelopmentDescription: 'Sono specializzato nella creazione di web app. Grazie ai framework Laravel e Angular posso dare forma alla tua idea.',
        consultingTitle: 'Consulenza',
        consultingDescription: 'Offro supporto nella scelta del software e hardware più adatti, con attenzione anche alla sicurezza informatica.',
        appDevelopmentTitle: 'Sviluppo applicativo',
        appDevelopmentDescription: 'Realizzo applicazioni native per Apple e Android e soluzioni cross-platform, garantendo performance elevate e un’ottima user experience.',
        cmsTitle: 'Content management system',
        cmsDescription: 'Comprendo l’importanza di un CMS robusto e personalizzato. Per questo offro soluzioni basate su WordPress, studiate per adattarsi perfettamente alle tue esigenze.',
        cloudAndServerSolutionsTitle: 'Soluzioni cloud e server',
        cloudAndServerSolutionsDescription: 'Con le mie competenze posso aiutarti negli ambiti cloud Google, Oracle e Microsoft, nei server on-premise e nella gestione dei dispositivi di rete.',
    },
};

export function Services() {
    const { language } = useLanguage();

    return (
        <>
            <SectionIntro
                eyebrow={ texts[language as keyof typeof texts]?.services || texts['en'].services }
                title={ texts[language as keyof typeof texts]?.servicesTitle || texts['en'].servicesTitle }
                className="mt-24 sm:mt-32 lg:mt-40">
                <p>
                    { texts[language as keyof typeof texts]?.servicesDescription || texts['en'].servicesDescription }
                </p>
            </SectionIntro>
            <Container className="mt-16">
                <div className="lg:flex lg:items-center lg:justify-end">
                    <div className="flex justify-center lg:w-1/2 lg:justify-end lg:pr-12">
                        <FadeIn className="w-[33.75rem] flex-none lg:w-[45rem]">
                            <StylizedImage
                                src={imageLaptop}
                                priority
                                fetchPriority="high"
                                quality={60}
                                sizes="(max-width: 480px) 92vw, (max-width: 768px) 88vw, (max-width: 1024px) 60vw, 41rem"
                                className="justify-center lg:justify-end"
                                alt="A laptop with a code editor open, showcasing web development work"
                            />
                        </FadeIn>
                    </div>
                    <List className="mt-16 lg:mt-0 lg:w-1/2 lg:min-w-[33rem] lg:pl-4">
                        <ListItem title={ texts[language as keyof typeof texts]?.webDevelopmentTitle || texts['en'].webDevelopmentTitle }>
                            { texts[language as keyof typeof texts]?.webDevelopmentDescription || texts['en'].webDevelopmentDescription }
                        </ListItem>
                        <ListItem title={ texts[language as keyof typeof texts]?.consultingTitle || texts['en'].consultingTitle }>
                            { texts[language as keyof typeof texts]?.consultingDescription || texts['en'].consultingDescription }
                        </ListItem>
                        <ListItem title={ texts[language as keyof typeof texts]?.appDevelopmentTitle || texts['en'].appDevelopmentTitle }>
                            { texts[language as keyof typeof texts]?.appDevelopmentDescription || texts['en'].appDevelopmentDescription }
                        </ListItem>
                        <ListItem title={ texts[language as keyof typeof texts]?.cmsTitle || texts['en'].cmsTitle }>
                            { texts[language as keyof typeof texts]?.cmsDescription || texts['en'].cmsDescription }
                        </ListItem>
                        <ListItem title={ texts[language as keyof typeof texts]?.cloudAndServerSolutionsTitle || texts['en'].cloudAndServerSolutionsTitle }>
                            { texts[language as keyof typeof texts]?.cloudAndServerSolutionsDescription || texts['en'].cloudAndServerSolutionsDescription }
                        </ListItem>
                    </List>
                </div>
            </Container>
        </>
    )
}
